/** @type {boolean | null} null = unknown / not yet synced this session */
let operational = null;
const listeners = new Set();

const notifyListeners = () => {
  for (const listener of listeners) {
    try {
      listener(operational);
    } catch (_) {
      // ignore subscriber errors
    }
  }
};

/** Whether FCM is actively delivering this session (confirmed token sync). */
export const isFcmOperational = () => operational === true;

/** @returns {boolean | null} */
export const getFcmOperationalState = () => operational;

export const markFcmOperational = (isOperational) => {
  const next = Boolean(isOperational);
  if (operational === next) {
    return;
  }
  operational = next;
  notifyListeners();
};

export const markFcmUnoperational = () => {
  if (operational === false) {
    return;
  }
  operational = false;
  notifyListeners();
};

export const resetFcmOperationalState = () => {
  if (operational === null) {
    return;
  }
  operational = null;
  notifyListeners();
};

/** Unknown until this session confirms FCM sync (see fcmSyncCoordinator). */
export const getInitialFcmOperationalState = () => null;

/** @param {(state: boolean | null) => void} listener @returns {() => void} */
export const subscribeFcmOperationalChanges = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
